// src/components/ProtectedRoute.tsx
import { useState } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import QuoteLayout from "../pages/common/component/QuoteLayout";
import { LandingPage } from "../pages/home/components/LandingPage";
import { Quote } from "../pages/quote/component/Quote";
import { QuoteRoute } from "./QuoteRoute";

const ProtectedRoute = () => {
  const [isShow, setIsShow] = useState(false);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="quote/*" element={<QuoteRoute />} />
        <Route
          path="proformaInvoice"
          element={<QuoteLayout isShow={true} setIsShow={setIsShow} />}
        >
          <Route
            path=""
            element={
              <Quote
                isShow={true}
                setIsShow={setIsShow}
                isShowInvoice={true}
                isQuoteOnly={true}
              />
            }
          />
        </Route>
        <Route
          path="quotation"
          element={<QuoteLayout isShow={true} setIsShow={setIsShow} />}
        >
          <Route
            path=""
            element={
              <Quote isShow={true} setIsShow={setIsShow} isQuoteOnly={true} />
            }
          />
        </Route>
        <Route path="home" element={<LandingPage />} />
        <Route path="*" element={<Navigate to="/home" />} />
      </Routes>
    </BrowserRouter>
  );
};

export default ProtectedRoute;
